import styled from 'styled-components'
import { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'

function applyStyles(type: ResourceTypeEnum) {
  if (type === ResourceTypeEnum.GROUP || type === ResourceTypeEnum.ROLE) {
    return 'margin-left: -2px;'
  }
  return ''
}

export interface Props {
  type?: ResourceTypeEnum
  styles?: string
  iconHash: string
  iconColor: string
}

const IcoMoon = styled.i<Props>`
  &:before {
    font-family:'icomoon';
    font-style: normal;
    ${props => applyStyles(props.type)}
    color: ${props => props.iconColor};
    content: "${props => props.iconHash}";
    ${props => props.styles}
`

export default IcoMoon
